import { useState } from "react";
import { ListArticle } from "../components/article/ListArticle";
import { CreateArticle } from "../components/article/CreateArticle";
import { UpdateArticle } from "../components/article/UpdateArticle";

export const Article = () => {
  const [mode, setMode] = useState<"list" | "create" | "edit">("list");
  const [selectedId, setSelectedId] = useState<string | null>(null);

  if (mode === "create") {
    return <CreateArticle onBack={() => setMode("list")} />;
  }

  if (mode === "edit" && selectedId) {
    return (
      <UpdateArticle
        onBack={() => {
          setSelectedId(null);
          setMode("list");
        }}
        selectedId={selectedId}
      />
    );
  }

  return (
    <ListArticle
      onCreate={() => setMode("create")}
      onUpdate={(id: string) => {
        setSelectedId(id);
        setMode("edit");
      }}
    />
  );
};
